<template>
	<div class="c-view">
		<InternalHeader>
			<div slot="title" class="c-internal-header__title">
				Roles
			</div>
			<role-create slot="actions" @sent="onRoleCreate">
				<Button slot="trigger" class="text-primary"
					><Icon :custom="'icon icon-add'" class="mr-3"></Icon> Create
					New Role
				</Button>
			</role-create>
		</InternalHeader>
		<Row class="mt-5" :gutter="16">
			<Col span="18">
				<p>Standard Roles</p>
				<roles-table
					class="mt-3"
					:loading="loading"
					:roles="standardRoles"
				></roles-table>
				<p class="mt-5">Custom Roles</p>
				<roles-table
					class="mt-3"
					:loading="loading"
					:roles="customRoles"
				></roles-table>
			</Col>
		</Row>
	</div>
</template>

<script>
export default {
	props: {
		rolesRepository: {
			type: Object,
			default: () => {
				return new (require("@/js/repositories/base.js"))(
					window.akita.urls.api + "/v1/roles"
				);
			},
		},
	},
	data() {
		return {
			loading: false,
			roles: [],
		};
	},
	components: {
		InternalHeader: function() {
			return import("@/js/components/partials/header");
		},
		Permissions: function() {
			return import("@/js/components/partials/permissions");
		},
		RolesTable: function() {
			return import("@/js/components/partials/roles-table");
		},
		RoleCreate: function() {
			return import("@/js/components/partials/role-create");
		},
	},
	async created() {
		this.load();
	},
	methods: {
		async load() {
			this.loading = true;
			const response = await this.rolesRepository.index();
			this.roles.push(...response.data.data);
			this.loading = false;
		},
		async onRoleCreate(role) {
			this.roles.push(role);
		},
	},
	computed: {
		customRoles() {
			return _.filter(this.roles, (role) => {
				return [3, 4, 5, 6].indexOf(role.id) < 0;
			});
		},
		standardRoles() {
			return _.filter(this.roles, (role) => {
				return [3, 4, 5, 6].indexOf(role.id) > -1;
			});
		},
	},
};
</script>
